<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务开发'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.salesPersonName"
              style="width: 100%"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.buyerName"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_purchaseDate') || '采购日期'"
            prop="purchaseDate"
          >
            <el-date-picker
              v-model="formData.purchaseDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_factoryPaymentTerms') || '工厂付款条件'"
            prop="factoryPaymentTerms"
          >
            <dict-select
              v-model="formData.factoryPaymentTerms"
              url="/master/common/dict/biz"
              :body="factoryPaymentTermsParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_quotedMethod') || '报价方式'"
            prop="quotedMethod"
          >
            <dict-select
              v-model="formData.quotedMethod"
              url="/sys/common/dict/system"
              :body="quotedMethodParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        buyerCode: '',
        buyerName: '',
        purchaseDate: dayjs().format('YYYY-MM-DD'),
        currencyUnit: 'CNY',
      },
      backDialogVisible: false,
      currencyUnitParams: { dictType: 'currencyUnit' },
      factoryPaymentTermsParams: { dictType: 'paymentTerms' },
      quotedMethodParams: { dictType: 'quotedMethod' },
      rules: {
        factoryPaymentTerms: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        purchaseDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
        this.formData.buyerCode = userCode || ''
        this.formData.buyerName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      if (this.loadingOpen()) return

      const params = { ...this.formData, ...this.params }
      const res = await this.$api
        .ecomHxPreOrderDetailScmPurchaseGenerateApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
